function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isConfirmYourAddressShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import ConfirmYourAddressPopup from './confirm-your-address-popup';
const formatPopupParamsSelector = createSelector(popupParamsSelector, params => {
  const {
    confirmAddresses
  } = params;
  if (!confirmAddresses) {
    return params;
  }
  return _objectSpread({}, params, {
    confirmAddresses: confirmAddresses.map(item => {
      // eslint-disable-next-line prefer-const
      let {
        address,
        unit
      } = item;
      if (unit) {
        address = address.replace(unit, '').trim();
      }
      return _objectSpread({}, item, {
        address
      });
    })
  });
});
const mapStateToProps = createStructuredSelector({
  isOpen: isConfirmYourAddressShownSelector,
  params: formatPopupParamsSelector
});
function getOnConfirmAddressAction(type) {
  return (dispatch, getState) => {
    const {
      onConfirmAddress
    } = popupParamsSelector(getState());
    dispatch(onConfirmAddress(type));
  };
}
function getOnEnterAddressAction(type) {
  return (dispatch, getState) => {
    const {
      onEnterAddress
    } = popupParamsSelector(getState());
    dispatch(onEnterAddress(type));
  };
}
const mapDispatchToProps = dispatch => bindActionCreators({
  onClose: hidePopup,
  onConfirmAddress: getOnConfirmAddressAction,
  onEnterAddress: getOnEnterAddressAction
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmYourAddressPopup);